export default "__VITE_ASSET__CEZe7RSU__"